<!--
  Renders nothing at all when the artefact has reached its final stage, which
  is the common case. A finished book gains no extra ink.

  `[title]` rather than `matTooltip`: this component is dropped into thumbnail
  grids, editor surfaces and cart rows, and `title` needs nothing in the host
  module's import list. The text is already translated in TS via LanguagePipe,
  so there is no `i18n-title` here - adding one would replace the computed,
  context-specific sentence with a single fixed string.
-->
<span *ngIf="visible"
      class="pqi"
      [class.pqi-error]="notice === 'ERROR'"
      [class.pqi-compact]="compact"
      [title]="hoverText"
      [attr.aria-label]="hoverText"
      role="img">
  <mat-icon class="pqi-icon">{{icon}}</mat-icon>
  <span class="pqi-label" *ngIf="!compact">{{label}}</span>
</span>

